(function () {
  'use strict';

  function showMonth () {
    return function (title) {
      const monthStrings = title.split(' ');

      return monthStrings[ 0 ];
    };
  }

  angular.module('web2print.shared')
    .filter('showMonth', showMonth);
})();
